module.exports = __webpack_public_path__ + "img/velvet.07c23fcf.jpg";